<script >
import { ref, computed, watch, defineAsyncComponent, onBeforeMount, onMounted } from 'vue-demi';
import PopupTransition from './PopupTransition/index.vue';
import useJudgeModalOpen from './useJudgeModalOpen';
import { FREQUENCY_INTERVAL } from '../common/constants';
const FlowContainer = defineAsyncComponent(() => Promise.resolve(require('@futuweb/fego-render')?.plugins.ComplexComp.Container.Flow));
const __sfc_main = {};
__sfc_main.props = {
  tpl: Object,
  defaultVisible: Number,
  zIndex: Number,
  clickMaskClose: {
    type: Boolean,
    default: true
  },
  lockScroll: {
    type: Boolean,
    default: false
  },
  frequencyInterval: Number,
  frequencyTimes: Number,
  frequencyLimit: Number,
  preload: {
    type: Boolean,
    default: false
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const isPreRender = window?.FEGORender?.common?.env?.isPreRender;
  const {
    useLockScreen,
    useTeleport,
    useZIndex,
    usePageType
  } = require('@fegobull/webapi').use;
  const {
    isPC
  } = usePageType();
  const props = __props;
  // 传送到body
  useTeleport(document.body);

  // 弹窗频率限制
  const {
    judgeModalOpen,
    recordOpen
  } = useJudgeModalOpen(props);
  const popupContent = ref();

  // 显示隐藏逻辑
  const visible = ref(!!props.defaultVisible);
  const isCalcFrequency = computed(() => props.frequencyInterval !== FREQUENCY_INTERVAL.NO_LIMIT);
  if (props.lockScroll) {
    useLockScreen(visible, popupContent);
  }
  const open = () => {
    console.log('open 调试', isCalcFrequency.value);
    // 频控情况下，才需要判断是否展示
    if (isCalcFrequency.value) {
      if (!judgeModalOpen()) {
        return;
      }
      recordOpen();
    }
    visible.value = true;
  };
  const close = () => {
    visible.value = false;
  };

  // 处理层级
  const zIndex = ref(0);
  if (props.zIndex !== 0 && !props.zIndex) {
    zIndex.value = useZIndex();
    watch(visible, () => {
      if (visible.value) {
        zIndex.value = useZIndex();
      }
    });
  } else {
    zIndex.value = props.zIndex;
  }
  const zIndexStyle = computed(() => ({
    zIndex: zIndex.value
  }));

  // 初始化默认展示的情况，也要判断频次
  onBeforeMount(() => {
    if (!!props.defaultVisible && isCalcFrequency.value) {
      if (!judgeModalOpen()) {
        visible.value = false;
        return;
      }
      recordOpen();
      visible.value = true;
    }
  });
  onMounted(() => {
    if (isPreRender) {
      return;
    }
  });

  // 对外暴露的方法
  return Object.assign({
    isPC,
    popupContent,
    visible,
    close,
    zIndexStyle
  }, {
    open,
    close
  });
};
__sfc_main.components = Object.assign({
  PopupTransition,
  FlowContainer
}, __sfc_main.components);
export default __sfc_main;
</script>
<template>
    <PopupTransition v-if="preload || visible">
        <div
            :class="[
                'basic-up-modal',
                {
                    pc: isPC,
                    active: visible
                }
            ]"
            v-show="visible"
            :style="zIndexStyle"
        >
            <div class="mask" @click="() => clickMaskClose && close()"></div>
            <div ref="content" class="popup-panel">
                <img
                    class="close-icon"
                    src="https://static.futunn.com/upload/01fego/close-icon-7abd5649416bbd149db0d9c9d8fe28db.png?_=1688980995952"
                    @click="close"
                    alt=""
                />
                <section ref="popupContent" class="popup-content">
                    <flow-container :children="tpl.children"></flow-container>
                </section>
            </div>
        </div>
    </PopupTransition>
    <div v-else class="empty-holder"></div>
</template>
<style lang="less" scoped>
@import './index.less';
.empty-holder {
    display: none;
}
</style>
